import { render } from "./approve-workspace.html?vue&type=template&id=78ab75f8&scoped=true&ts=true"
import script from "./approve-workspace.ts?vue&type=script&lang=ts"
export * from "./approve-workspace.ts?vue&type=script&lang=ts"

import "./approve-workspace.scss?vue&type=style&index=0&id=78ab75f8&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78ab75f8"]])

export default __exports__